<template>
  <div>
    <v-dialog
      v-model="applicabilityDialog"
      max-width="900"
      :fullscreen="$vuetify.display.smAndDown"
      scrollable
      :retain-focus="false"
    >
      <v-card>
        <v-card-title
          class="redColor infocar-appl-title d-flex align-center ga-2"
        >
          <span
            class="text-subtitle-1 font-weight-medium text-white flex-grow-1 infocar-appl-title-text"
          >
            {{ $t("parts.infoCar.applicability") }}
          </span>
          <v-btn
            variant="outlined"
            icon
            color="white"
            class="infocar-appl-close-btn flex-shrink-0"
            size="small"
            @click="closeAppl"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row v-if="applicability">
            <v-col cols="12">
              <div class="infocar-table-wrap">
                <v-data-table
                  :headers="headers"
                  :items="applicability"
                  item-key="_id"
                  hide-default-footer
                >
                  <!-- Table body -->
                  <template #item="{ item, index }">
                    <tr
                      :class="
                        index % 2 == 0
                          ? 'inventoryDialogDatatableRow white--text'
                          : 'bg-grey-lighten-2'
                      "
                      class="pa-1"
                      @click="toggleExpand(item)"
                    >
                      <td class="text-xs pa-2">
                        {{ item.brand }}
                      </td>
                      <td class="text-xs">
                        <span v-if="item.modelId">
                          {{ item.modelId.description }}
                        </span>
                      </td>
                      <td class="text-xs">
                        <span v-if="item.modelId">
                          {{ formatMonthYear(item.modelId.startingDate) }}
                          &nbsp;-&nbsp;
                          {{ formatMonthYear(item.modelId.endingDate) }}
                        </span>
                      </td>
                      <td>
                        <v-btn
                          icon
                          variant="text"
                          @click.stop="toggleExpand(item)"
                        >
                          <v-icon>{{
                            isExpanded(item)
                              ? "mdi-chevron-up"
                              : "mdi-chevron-down"
                          }}</v-icon>
                        </v-btn>
                      </td>
                    </tr>

                    <!-- Expanded row -->
                    <tr v-if="isExpanded(item)">
                      <td :colspan="headers.length">
                        <div class="infocar-table-wrap infocar-subtable-wrap">
                          <v-data-table
                            :headers="subheaders"
                            :items="item.versions"
                            hide-default-footer
                            class="grey"
                          >
                            <template #item="{ item: sitem }">
                              <tr class="tableRowColor">
                                <td class="text-xs">
                                  {{ sitem.version }}
                                </td>
                                <td v-if="sitem.versionId" class="text-xs">
                                  {{
                                    formatMonthYear(sitem.versionId.startingDate)
                                  }}
                                  &nbsp;-&nbsp;
                                  {{ formatMonthYear(sitem.versionId.endingDate) }}
                                </td>
                                <td v-if="sitem.versionId" class="text-xs">
                                  {{ sitem.versionId.numberOfDoors }}
                                  {{ $t("parts.infoCar.doors") }}
                                </td>
                                <td v-if="sitem.versionId" class="text-xs">
                                  {{ sitem.versionId.power.kw }} kw
                                </td>
                                <td v-if="sitem.versionId" class="text-xs">
                                  {{ sitem.versionId.engineCode }}
                                </td>
                                <td v-if="sitem.versionId" class="text-xs">
                                  {{
                                    getSupplyLocale(sitem.versionId.supplyCode)
                                  }}
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--------------------------------------------------------------------------------------------->
    <v-dialog
      v-model="cadDialog"
      persistent
      max-width="900"
      :fullscreen="$vuetify.display.smAndDown"
      scrollable
      :retain-focus="false"
    >
      <v-card flat>
        <v-card-title class="redColor infocar-cad-title d-flex align-center ga-2">
          <span
            class="text-subtitle-1 font-weight-medium text-white flex-grow-1 infocar-cad-title-text"
          >
            {{ $t("institutions.form.infoCarCad") }}
          </span>
          <v-btn
            variant="outlined"
            icon
            color="white"
            class="infocar-cad-close-btn flex-shrink-0"
            size="small"
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <!--LOADER-->
          <v-row v-if="loadingCad" class="justify-center">
            <v-progress-circular indeterminate size="50" color="red-darken-2" />
          </v-row>

          <v-container v-else fluid class="pa-0">
            <v-row class="justify-center mt-2 flex-wrap">
              <v-col cols="12" md="8" lg="6">
                <v-text-field
                  v-model="code"
                  variant="solo"
                  single-line
                  hide-details
                  :label="$t('vehicle_entry.code')"
                  @keyup.enter="getApplicability"
                />
              </v-col>

              <v-col cols="12" md="4" lg="auto" class="d-flex align-center">
                <v-btn
                  color="red-darken-2"
                  dark
                  class="infocar-appl-btn"
                  :loading="loadingAppl"
                  @click="getApplicability"
                >
                  {{ $t("vehicle_entry.get_applicability") }}
                </v-btn>
              </v-col>
              <v-col cols="12" class="pt-2">
                <iframe
                  v-if="source"
                  ref="cadIframe"
                  :src="source"
                  class="infocar-cad-iframe"
                  :class="{ 'infocar-cad-iframe--compact': spareParts.length }"
                  width="100%"
                  @error="onCadIframeError"
                />
                <div class="text-caption text-medium-emphasis mt-2">
                  {{ $t("parts.infoCar.clickPartHint") }}
                </div>
              </v-col>
              <v-col v-if="spareParts.length" cols="12" class="pt-1">
                <div class="text-subtitle-2 font-weight-medium mb-2">
                  {{ $t("parts.infoCar.selectedCorrespondences") }}
                </div>
                <div class="infocar-table-wrap">
                  <v-table density="compact" class="infocar-spare-table">
                    <thead>
                      <tr>
                        <th>{{ $t("parts.table.oem_code") }}</th>
                        <th>{{ $t("parts.infoCar.description") }}</th>
                        <th class="text-right" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(part, index) in spareParts" :key="part.id || part.oe || index">
                        <td class="text-body-2 font-weight-medium">
                          {{ part.oe }}
                        </td>
                        <td class="text-body-2">
                          {{ part.ds }}
                        </td>
                        <td class="text-right infocar-spare-actions">
                          <div class="d-flex align-center justify-end ga-2 infocar-spare-actions-row">
                            <v-chip
                              size="small"
                              variant="outlined"
                              class="infocar-count-chip"
                            >
                              <img
                                class="infocar-count-logo"
                                src="https://portal.lekotech.com/logo_small.png"
                                alt="LekoTech"
                              />
                              <span v-if="countsLoading">…</span>
                              <span v-else>{{ oemCount(part.oe).leko }}</span>
                            </v-chip>
                            <v-chip
                              v-if="isRrMember"
                              size="small"
                              variant="outlined"
                              class="infocar-count-chip"
                            >
                              <img
                                class="infocar-count-logo"
                                src="@/assets/rr-logo.png"
                                alt="Rete Ricambi"
                              />
                              <span v-if="countsLoading">…</span>
                              <span v-else>{{ oemCount(part.oe).rr }}</span>
                            </v-chip>
                            <v-btn
                              size="small"
                              color="red-darken-2"
                              variant="tonal"
                              :disabled="!part.oe"
                              @click="searchInventory(part.oe)"
                            >
                              <v-icon start size="18">mdi-magnify</v-icon>
                              {{ $t("parts.infoCar.searchInventory") }}
                            </v-btn>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import getRequest from "../api/getRequest";
import postRequest from "../api/postRequest";

export default {
  emits: ["search-oem"],
  filters: {
    moment(date) {
      moment.locale(localStorage.getItem("language"));
      const currentMonth = new Date().toISOString();
      let returnedDate = "";
      if (!date) {
        returnedDate = moment(currentMonth).format("MM/YYYY");
      } else {
        returnedDate = moment(date).format("MM/YYYY");
      }
      return returnedDate;
    },
  },
  data: () => ({
    code: null,

    cadDialog: false,
    loadingCad: false,
    source: null,

    applicabilityDialog: false,
    loadingAppl: false,
    applicability: null,
    spareParts: [],
    inventoryCounts: {},
    countsLoading: false,
    _countSeq: 0,
    cadToken: null,
    cadFallbackUsed: false,
    expand: false,
    openExpand: false,
    headers: [
      {
        title: "Brand",
        sortable: false,
        key: "brand",
      },
      {
        title: "Model",
        sortable: false,
        key: "model",
      },
      {
        title: "Year",
        sortable: false,
        key: "year",
      },
      { title: "", key: "data-table-expand" },
    ],
    subheaders: [
      {
        title: "Version",
        sortable: false,
        key: "",
      },
      {
        title: "Year",
        sortable: false,
        key: "",
      },
      {
        title: "Body",
        sortable: false,
        key: "",
      },
      {
        title: "Power",
        sortable: false,
        key: "",
      },
      {
        title: "Engine",
        sortable: false,
        key: "",
      },
      {
        title: "Fuel",
        sortable: false,
        key: "",
      },
    ],
    expandedItems: [],
  }),
  computed: {
    isRrMember() {
      return this.$store.getters.rr_member === true;
    },
  },
  watch: {
    applicabilityDialog(value) {
      if (!value) {
        this.closeAppl();
      }
    },
  },
  created() {
    this.getLocale();
    this._onCadMessage = (event) => this.onCadMessage(event);
    window.addEventListener("message", this._onCadMessage);
    window.__lekoApplyCadParts = (parts) => this.applySpareParts(parts);
  },
  beforeUnmount() {
    window.removeEventListener("message", this._onCadMessage);
    if (window.__lekoApplyCadParts) delete window.__lekoApplyCadParts;
  },
  methods: {
    getLocale() {
      this.headers[0].title = this.$t("parts.infoCar.brand");
      this.headers[1].title = this.$t("parts.infoCar.model");
      this.headers[2].title = this.$t("parts.infoCar.year");
      this.subheaders[0].title = this.$t("parts.infoCar.version");
      this.subheaders[1].title = this.$t("parts.infoCar.year");
      this.subheaders[2].title = this.$t("parts.infoCar.body");
      this.subheaders[3].title = this.$t("parts.infoCar.power");
      this.subheaders[4].title = this.$t("parts.infoCar.engine");
      this.subheaders[5].title = this.$t("parts.infoCar.supply.title");
    },
    getSupplyLocale(supply) {
      switch (supply) {
        case "B":
          return this.$t("parts.infoCar.supply.petrol");
        case "D":
          return this.$t("parts.infoCar.supply.diesel");
        case "G":
          return this.$t("parts.infoCar.supply.gas");
        default:
          return supply;
      }
    },

    open(data) {
      this.cadDialog = true;
      this.loadingCad = true;
      this.spareParts = [];
      this.inventoryCounts = {};
      this.countsLoading = false;
      this._countSeq += 1;
      this._spareKey = "";
      this.cadFallbackUsed = false;
      getRequest(
        "/info-car/cad",
        `brandCode=${data.brandCode}&modelCode=${data.modelCode}&versionCode=${data.versionCode}`,
      )
        .then((response) => {
          this.cadToken = response.token;
          this.source = this.cadIframeSrc(response.token);
        })
        .catch(() => {
          this.loadingCad = false;
        })
        .finally(() => {
          this.loadingCad = false;
        });
    },
    getApplicability() {
      this.loadingAppl = true;
      getRequest("/info-car/search", `code=${this.code}&populated=true`)
        .then((response) => {
          if (response && response.length) {
            this.openAppl(response[0].applicability);
          }
        })
        .catch(() => {
          this.loadingCad = false;
        })
        .finally(() => {
          this.loadingAppl = false;
        });
    },

    async openAppl(applicability) {
      this.cadDialog = false;
      this.applicability = applicability;
      this.applicabilityDialog = true;
    },
    closeAppl() {
      this.cadDialog = true;
      this.applicabilityDialog = false;
      this.loadingAppl = false;
      this.applicability = null;
      this.expand = false;
    },
    close() {
      this.closeAppl();
      this.cadDialog = false;
      this.loadingCad = false;
      this.source = null;
      this.code = null;
      this.spareParts = [];
      this.inventoryCounts = {};
      this.countsLoading = false;
      this._countSeq += 1;
      this.cadToken = null;
      this.cadFallbackUsed = false;
      this._spareKey = "";
    },
    cadIframeSrc(token) {
      const qs = `token=${encodeURIComponent(token)}&DWI=10&Lang=IT-it`;
      const path = `/LRW/application.m?${qs}`;
      const base = String(this.$serverUri || "").replace(/\/$/, "");
      // Always load CAD from the API host, never from the portal path.
      // A relative /LRW URL is handled by Vue Router and renders the portal
      // inside the iframe.
      if (base.startsWith("http") || base.startsWith("//")) {
        return `${base}${path}`;
      }
      if (base.startsWith("/")) {
        return `${window.location.origin}${base}${path}`;
      }
      return `${window.location.protocol}//localhost:3000${path}`;
    },
    onCadIframeError() {
      if (this.cadFallbackUsed || !this.cadToken) return;
      this.cadFallbackUsed = true;
      this.source = `https://infocar-repair.quattroruotepro.it/LRW/application.m?token=${this.cadToken}&DWI=10&Lang=IT-it`;
    },
    isTrustedCadOrigin(origin) {
      try {
        const { hostname } = new URL(origin);
        if (hostname === "infocar-repair.quattroruotepro.it") return true;
        if (hostname === "localhost" || hostname === "127.0.0.1") return true;
        if (/^(10\.|192\.168\.|172\.(1[6-9]|2\d|3[0-1])\.)/.test(hostname)) {
          return true;
        }
        if (hostname === "lekotech.com" || hostname.endsWith(".lekotech.com")) {
          return true;
        }
        return false;
      } catch {
        return false;
      }
    },
    extractPartsFromMessage(data) {
      if (!data) return [];
      if (Array.isArray(data)) return data;
      if (typeof data === "object") {
        if (Array.isArray(data.parts)) return data.parts;
        if (data.oe) return [data];
      }
      if (typeof data === "string") {
        try {
          return this.extractPartsFromMessage(JSON.parse(data));
        } catch {
          const found = [];
          const oeRe =
            /<(?:oe|OE|OemCode|oemCode)[^>]*>([^<]+)<\/(?:oe|OE|OemCode|oemCode)>/g;
          const dsRe =
            /<(?:ds|DS|Descrizione|description)[^>]*>([^<]+)<\/(?:ds|DS|Descrizione|description)>/g;
          const oes = [...data.matchAll(oeRe)].map((m) => m[1].trim());
          const dss = [...data.matchAll(dsRe)].map((m) => m[1].trim());
          oes.forEach((oe, i) => {
            found.push({ oe, ds: dss[i] || "" });
          });
          return found;
        }
      }
      return [];
    },
    applySpareParts(parts) {
      const rows = (Array.isArray(parts) ? parts : [])
        .filter((part) => part && part.oe)
        .map((part) => ({
          id: part.id,
          oe: String(part.oe).trim(),
          ds: part.ds || "",
          prz: part.prz,
          vl: part.vl,
        }));
      const key = rows.map((row) => row.oe).join("|");
      if (rows.length && key !== this._spareKey) {
        this._spareKey = key;
        this.spareParts = rows;
        this.fetchInventoryCounts(rows);
      }
    },
    oemCount(oe) {
      const key = String(oe || "").trim().toUpperCase();
      return this.inventoryCounts[key] || { leko: 0, rr: 0 };
    },
    async fetchInventoryCounts(rows) {
      const oemCodes = [
        ...new Set(
          (rows || [])
            .map((row) => String(row.oe || "").trim())
            .filter(Boolean),
        ),
      ];
      this._countSeq += 1;
      const seq = this._countSeq;
      if (!oemCodes.length) {
        this.inventoryCounts = {};
        this.countsLoading = false;
        return;
      }
      this.countsLoading = true;
      try {
        const response = await postRequest.object(
          "/info-car/inventory-oem-counts",
          { oemCodes },
        );
        if (seq !== this._countSeq) return;
        this.inventoryCounts = (response && response.data && response.data.counts) || {};
      } catch {
        if (seq !== this._countSeq) return;
        this.inventoryCounts = {};
      } finally {
        if (seq === this._countSeq) this.countsLoading = false;
      }
    },
    onCadMessage(event) {
      if (!this.cadDialog) return;
      if (!this.isTrustedCadOrigin(event.origin)) return;
      const data = event.data;
      if (!data || typeof data !== "object" || data.source !== "leko-infocar") {
        return;
      }
      this.applySpareParts(this.extractPartsFromMessage(data));
    },
    searchInventory(oe) {
      const code = String(oe || "").trim();
      if (!code) return;
      const { href } = this.$router.resolve({
        path: "/inventory",
        query: { type: "other", q: code },
      });
      window.open(href, "_blank", "noopener,noreferrer");
    },
    formatMonthYear(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // months are 0-indexed
      const year = date.getUTCFullYear();
      return `${month}/${year}`;
    },
    toggleExpand(item) {
      const key = item._id;
      const index = this.expandedItems.indexOf(key);
      if (index === -1) {
        this.expandedItems.push(key);
        this.openExpand = true;
      } else {
        this.expandedItems.splice(index, 1);
      }
    },
    isExpanded(item) {
      if (item && item._id) {
        return this.expandedItems.includes(item._id);
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.infocar-cad-title,
.infocar-appl-title {
  padding: 12px 16px;
}

.infocar-cad-title-text,
.infocar-appl-title-text {
  min-width: 0;
  line-height: 1.35;
  word-break: break-word;
}

.infocar-spare-actions {
  white-space: nowrap;
  width: 1%;
}
.infocar-spare-actions-row {
  flex-wrap: nowrap;
}
.infocar-count-chip {
  padding-inline: 6px;
  flex-shrink: 0;
  pointer-events: none;
}
.infocar-count-logo {
  height: 16px;
  width: 16px;
  object-fit: contain;
  margin-right: 6px;
}
.infocar-spare-table :deep(.v-table) {
  min-width: 780px;
}

.infocar-cad-iframe {
  display: block;
  width: 100%;
  height: 610px;
  border: 0;
}

.infocar-cad-iframe--compact {
  height: 420px;
}

@media (max-width: 959.98px) {
  .infocar-cad-title,
  .infocar-appl-title {
    position: relative;
    padding: 12px 52px 12px 16px;
  }

  .infocar-cad-close-btn,
  .infocar-appl-close-btn {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
  }

  .infocar-appl-btn {
    width: 100%;
  }

  .infocar-cad-iframe {
    height: calc(100dvh - 200px);
    min-height: 320px;
  }

  .infocar-cad-iframe--compact {
    height: calc(100dvh - 340px);
    min-height: 220px;
  }

  .infocar-table-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    max-width: 100%;
  }

  .infocar-table-wrap :deep(.v-table) {
    min-width: 780px;
  }

  .infocar-subtable-wrap :deep(.v-table) {
    min-width: 640px;
  }
}
</style>
